// Home - Main authenticated app wrapper
// Updated as part of ENG2-1701: Update Routing and Page Integration

import React from 'react'
import {
  SnackbarProvider as SnackbarProviderOriginal,
  SnackbarProviderProps,
} from 'notistack'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { SxProps, Theme } from '@mui/material'
import { AppLayout } from 'layouts'
import CustomersPage from './customers-page'
import ZonesPage from './zones-page'
import CustomerDetailPage from './customer-detail-page'
import EscalationsPage from './escalations-page'
import CustomerGroupsPage from './customer-groups-page'
import BannersPage from './banners-page'
import GlobalDataUsagePage from './global-data-usage-page'
import NordicLookupsUsagePage from './nordic-lookups-usage-page'
import { useCustomers } from 'services/queries/use-customers'

// Type assertion to fix React types incompatibility between notistack and react-intl
const SnackbarProvider = SnackbarProviderOriginal as unknown as React.FC<
  SnackbarProviderProps & { sx?: SxProps<Theme> }
>

const snackbar: SxProps<Theme> = {
  '& .SnackbarContent-root': {
    fontSize: '14px',
  },
}

const HomeContent: React.FC = () => {
  const { data: customers } = useCustomers()
  const customerCount = Array.isArray(customers) ? customers.length : undefined

  return (
    <AppLayout customerCount={customerCount}>
      <Routes>
        <Route path="/" element={<CustomersPage />} />
        <Route path="/zones" element={<ZonesPage />} />
        <Route path="/global-data-usage" element={<GlobalDataUsagePage />} />
        <Route
          path="/nordic-lookups-usage"
          element={<NordicLookupsUsagePage />}
        />
        <Route path="/customer/:id" element={<CustomerDetailPage />} />
        <Route path="/customer-groups" element={<CustomerGroupsPage />} />
        <Route path="/banners" element={<BannersPage />} />
        <Route path="/escalations" element={<EscalationsPage />} />
      </Routes>
    </AppLayout>
  )
}

const Home: React.FC = () => {
  return (
    <BrowserRouter>
      <SnackbarProvider
        maxSnack={1}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={snackbar}
      >
        <HomeContent />
      </SnackbarProvider>
    </BrowserRouter>
  )
}

export default Home
